import { createElement, type ElementType } from "react";
import { render } from "react-dom";

type ComponentMap = Record<string, ElementType>;

export const mountComponents = (components: ComponentMap): void => {
  const nodes = window.document.querySelectorAll<HTMLElement>("[data-react-class]");

  nodes.forEach((node) => {
    const componentName = node.getAttribute("data-react-class");
    if (componentName === null) return;

    const component = components[componentName];
    if (component === undefined) {
      const message = `Cannot find component: '${componentName}'`;
      // eslint-disable-next-line no-console
      console.log(`%c[mountComponents] %c${message} for element`, "font-weight: bold", "", node);
      throw new Error(`[mountComponents] ${message}`);
    }

    const propsJson = node.getAttribute("data-react-props");
    const props = propsJson ? (JSON.parse(propsJson) as Record<string, unknown>) : null;

    render(createElement(component, props), node);
  });
};
